module.exports = __webpack_public_path__ + "img/live2.75dafc9c.jpeg";